module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA50lEQVQoU5XQvUoDYRCF4fckiJFNEbwCb8BKEzBVCktLsRQEs5ZiZy+KlVWatbEQq/USIqZUFsVGwZsINopBkyNfQiCF+RuYbh5m5og5S+XE14htoDPFFjCpypf+ihZYbu3pexLYuPDSb5F2AB9ZrNIsl4XZAM6zWMfzgEPgdaXEfbqj7iQ43HACbAFRTuw+1vUwDvXBeuIjQzMPqxaNntl8OtDzf6gPKolPLfaBM0HHUM9irY0F4emeucmJlvNU1eUunJjFehlFtSsXPn8Gsd7KvFtEiDebCtDU4K/Qw1oUpJolztGZP8mdXevboVitAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/fgmt.png
// module id = iKoG
// module chunks = 1